export default class Header {
  constructor(element) {
    this.element = element;
    this.dataTreshold = this.element.dataset.treshold;
    this.options = {
      treshold: this.dataTreshold,
    };
    this.scrollPosition = 0;
    this.lastScrollPosition = 0;
    this.html = document.documentElement;
    console.log('yep');
    this.init();
    this.initNavMobile();
  }

  init() {
    console.log(this.dataTreshold);
    this.setOptions();

    window.addEventListener('scroll', this.onScroll.bind(this));
  }
  initNavMobile() {
    const toggle = this.element.querySelector('.js-toggle');
    toggle.addEventListener('click', this.onToggleNav.bind(this));
  }

  onToggleNav() {
    this.html.classList.toggle('nav-is-active');
  }

  onScroll() {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;
    if ('alwaysShow' in this.element.dataset) {
      console.log('YA UN DATASHOW');
    } else {
      this.setDirections();
      this.setHeaderState();
    }
  }

  setHeaderState() {
    if (
      this.scrollPosition >
      document.scrollingElement.scrollHeight * this.options.treshold
    ) {
      this.html.classList.add('header-is-hidden');
    } else if (this.scrollPosition < this.lastScrollPosition) {
      this.html.classList.remove('header-is-hidden');
    }
  }

  setDirections() {
    if (this.lastScrollPosition < this.scrollPosition) {
      this.html.classList.add('is-scrolling-down');
      this.html.classList.remove('is-scrolling-up');
    } else {
      this.html.classList.add('is-scrolling-up');
      this.html.classList.remove('is-scrolling-down');
    }
  }
  setOptions() {}
}
